import { Text } from '@inflearn/ds-react';

export function UserSlug({ slug }: { slug: string }) {
  return (
    <Text size="md" weight="400" lh="1.3" color="gray.6">
      @{slug}
    </Text>
  );
}
